import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActionCoCalculatorMission, ActionCoCalculatorModel, ActionCoCalculatorTab, ActionCoCollaborateurMission, ActionCoMissionGroup, ActionCoMissionPDCGrouped, ActionCoMissionProperty, ActionCoMissionQuestion, BObjectModel, Corporation } from '../../../models';
import { CoreService, HttpService } from '../../../services';
import { ActionCoService } from '../action-co-services/action-co.service';

@Injectable({
  providedIn: 'root'
})

export class ActionCoCalculatorService implements OnDestroy {
  public dataLoading: boolean = false;
  public savingMission: boolean = false;
  public LinkedMissions: Array<ActionCoCalculatorMission> = new Array<ActionCoCalculatorMission>();
  public UnlinkedMissions: Array<ActionCoCalculatorMission> = new Array<ActionCoCalculatorMission>();
  public Collaborateurs: Array<ActionCoCollaborateurMission> = new Array<ActionCoCollaborateurMission>();
  public Discount: number = 0;
  public Amount: number = 0;
  public bObjectModel: BObjectModel = new BObjectModel();
  public lockTabs: boolean = false;
  private iMission: number = -1;

  get Mission(): ActionCoCalculatorMission {
    if (this.iMission > -1)
      return this.LinkedMissions[this.iMission];
    return new ActionCoCalculatorMission();
  }
  set Mission(mission: ActionCoCalculatorMission) {
    let index: number = -1;
    if (mission) {
      let missions: { Ident: string, Index: number }[] = [];
      this.LinkedMissions.forEach((m: ActionCoCalculatorMission, i: number) => {
        if (m.CodeBo === mission.CodeBo) {
          missions.push({ Ident: m.Ident, Index: i });
        }
      });
      if (missions.length > 1) {
        index = missions.findIndex(m => m.Ident === mission.Ident);
        index = index > -1 ? index : missions[0].Index;
      } else {
        index = missions.length === 1 ? missions[0].Index : -1;
      }

      if (index > -1) {
        this.LinkedMissions[index].Ident = mission.Ident;
        this.LinkedMissions[index].Label = mission.Label;
        this.LinkedMissions[index].BoName = mission.BoName;
        this.LinkedMissions[index].Discount = mission.Discount;
        this.LinkedMissions[index].Amount = mission.Amount;
        this.LinkedMissions[index].Groups = mission.Groups;
        this.LinkedMissions[index].globalInformationGroup = mission.globalInformationGroup;
        this.LinkedMissions[index].ClientsProperties = mission.ClientsProperties;
        this.LinkedMissions[index].MissionsProperties = mission.MissionsProperties;
        this.LinkedMissions[index].ObligationsProperties = mission.ObligationsProperties;
        this.LinkedMissions[index].Cacs = mission.Cacs;
        this.LinkedMissions[index].loadingDatas = mission.loadingDatas;
        this.AffectRequiredMissionProperties(this.LinkedMissions[index]);
      }
    }
  }

  constructor(
    protected http: HttpService,
    public indParam: CoreService,
  ) { }

  public SetDefaultMission() {
    this.iMission = this.LinkedMissions.length > 0 ? 0 : -1
    this.bObjectModel.IdDonneeFils = this.Mission.Ident;
  }

  public OnChangeMission(CodeBo: string, Ident: string) {
    this.bObjectModel.IdDonneeFils = Ident;
    const missions: { Ident: string, Index: number }[] = [];
    //#region récupération de la liste des missions avec le même code bo
    this.LinkedMissions.forEach((m: ActionCoCalculatorMission, i: number) => {
      if (m.CodeBo === CodeBo) {
        missions.push({ Ident: m.Ident, Index: i });
      }
    });
    //#endregion

    if (missions.length === 1) {
      this.iMission = missions[0].Index;
    } else {
      // si li y a plus d'une mission on prend soit celle qui possède le même ident que celui passé en paramètre, soit la première mission de la liste
      this.iMission = missions.findIndex(m => m.Ident === Ident);
    }
  }

  //sert à réinitialiser toutes les valeurs du service lorsque l'on change d'action commerciale.
  public InitVariables(): void {
    this.LinkedMissions = new Array<ActionCoCalculatorMission>();
    this.UnlinkedMissions = new Array<ActionCoCalculatorMission>();
    this.Collaborateurs = new Array<ActionCoCollaborateurMission>();
    this.Amount = 0;
    this.Discount = 0;
    this.lockTabs = false;
  }

  // récupères toutes le propriétés obligatoires qui ne sont pas affectées à une question
  public AffectRequiredMissionProperties(mission: ActionCoCalculatorMission): void {
    const question = new ActionCoMissionQuestion();
    question.Label = '';
    question.Description = '';

    //parcours la liste des propriétés restantes pour n'extraire que celles obligatoires et les ajouter à une question volante.
    if (mission.MissionsProperties) {
      mission.MissionsProperties.forEach((property: ActionCoMissionProperty) => {
        if (property && property.Value.MainElementList && property.Value.MainElementList.length > 0 && property.Value.MainElementList[0].Required) {
          question.Properties.push(property);
        }
      });
    }
    // injecte la question créée avec le propritétés obligatoires dans le groupe des informations globales.
    if (mission.globalInformationGroup.Questions.length > 0) {
      mission.globalInformationGroup.Questions[0].Properties = question.Properties;
    } else {
      mission.globalInformationGroup.Questions.push(question);
    }
    mission.globalInformationGroup.ShowCalculGroup = mission.globalInformationGroup.Questions[0].Properties.length > 0;
  }

  public CalculTotalAmount() {
    this.Amount = 0;
    this.LinkedMissions.forEach((m: ActionCoCalculatorMission, i: number) => {
      this.Amount += m.Amount;
    });
  }
  //#region gestion des groupes
  public AddGroup(mission: ActionCoCalculatorMission): void {
    const group: ActionCoMissionGroup = new ActionCoMissionGroup();
    //group.Order = mission.Groups.length + 1;
    const question = new ActionCoMissionQuestion();
    question.Order = 1;
    group.Questions.push(question);
    group.Order = mission.Groups.push(group);
    let scrollParent: JQuery = ($('q-action-co-calculateur') as any).scrollParent();
    if (scrollParent) {
      scrollParent[0].style.scrollBehavior = 'smooth';
      setTimeout(() => {       
        scrollParent[0].scrollTo(scrollParent[0].scrollHeight, scrollParent[0].scrollHeight);
      }, 10);
    }
    this.Mission = mission;
  }

  public ToggleGroup(group: ActionCoMissionGroup, value: boolean): void {
    if (value) {
      group.PreLoadVisibility = true;
    } else {
      setTimeout(() => {
        group.PreLoadVisibility = false;
      }, 500);
    }
    setTimeout(() => { group.Visible = value }, 100);
  }

  public ToggleQuestion(question: ActionCoMissionQuestion, value: boolean): void {
    if (value) {
      question.PreLoadVisibility = true;
    } else {
      setTimeout(() => {
        question.PreLoadVisibility = false;
      }, 500);
    }
    setTimeout(() => { question.Visible = value }, 100);
  }
  //#endregion
  ngOnDestroy(): void {

  }
}
